import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewScreening from "@/pages/NewScreening";
import Search from "@/pages/Search";
import BatchScreening from "@/pages/BatchScreening";
import ScreeningResult from "@/pages/ScreeningResult";
import ReviewQueue from "@/pages/ReviewQueue";
import CaseHistory from "@/pages/CaseHistory";
import AuditLog from "@/pages/AuditLog";
import SanctionsStatus from "@/pages/SanctionsStatus";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="grid-bg flex min-h-screen items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user && user !== false && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/new" element={<Protected><RoleRoute roles={["analyst", "reviewer", "admin"]}><NewScreening /></RoleRoute></Protected>} />
            <Route path="/search" element={<Protected><RoleRoute roles={["analyst", "reviewer", "admin"]}><Search /></RoleRoute></Protected>} />
            <Route path="/batch" element={<Protected><RoleRoute roles={["analyst", "reviewer", "admin"]}><BatchScreening /></RoleRoute></Protected>} />
            <Route path="/review" element={<Protected><ReviewQueue /></Protected>} />
            <Route path="/cases" element={<Protected><CaseHistory /></Protected>} />
            <Route path="/cases/:id" element={<Protected><ScreeningResult /></Protected>} />
            <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
            <Route path="/sanctions" element={<Protected><SanctionsStatus /></Protected>} />
            <Route path="/users" element={<Protected><RoleRoute roles={["admin"]}><Users /></RoleRoute></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
